import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE = 'Carper Sports'
export const DEFAULT_DESC =
  'Équipements sportifs aux tarifs clubs — ballons, maillots, textile et accessoires. Flocage et sublimation sur mesure. Livraison rapide partout en France.'

interface Props {
  title: string
  description?: string
  /** URL canonique absolue. Si omis, utilise pathname sans query string. */
  canonical?: string
  /** URL image pour les og:image (absolue) */
  image?: string
  type?: 'website' | 'product' | 'article'
}

function upsert(attr: string, content: string, prop = false) {
  const sel = prop ? `meta[property="${attr}"]` : `meta[name="${attr}"]`
  let el = document.querySelector<HTMLMetaElement>(sel)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(prop ? 'property' : 'name', attr)
    document.head.appendChild(el)
  }
  el.content = content
}

export default function SEOHead({ title, description = DEFAULT_DESC, canonical, image, type = 'website' }: Props) {
  const location = useLocation()

  useEffect(() => {
    const fullTitle = `${title} | ${SITE}`
    document.title = fullTitle

    upsert('description', description)
    upsert('og:title', fullTitle, true)
    upsert('og:description', description, true)
    upsert('og:type', type, true)
    upsert('og:site_name', SITE, true)
    if (image) upsert('og:image', image, true)

    // Canonical : préférence au prop, sinon pathname sans query
    const href = canonical ?? (window.location.origin + location.pathname)
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'canonical'
      document.head.appendChild(link)
    }
    link.href = href
    upsert('og:url', href, true)
  }, [title, description, canonical, image, type, location.pathname])

  return null
}
